import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {BsDatepickerModule} from 'ngx-bootstrap';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { ChartsModule} from 'ng2-charts/ng2-charts';
import { NgxSelectModule } from 'ngx-select-ex';
import { DpDatePickerModule} from 'ng2-date-picker';
import { TooltipModule} from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { NgxJsonViewerModule } from 'ngx-json-viewer';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {NgCircleProgressModule} from 'ng-circle-progress';


import {DndModule} from 'ng2-dnd';


import { ListVnaServicesComponent } from './config/vna_services/components/list-vna-services/list-vna-services.component';
import { ListLogsComponent } from './analytics/logs/components/list-logs/list-logs.component';
import { ElementLogsComponent } from './tools/elements/components/element-logs/element-logs.component';
import { ElementCacheComponent } from './tools/elements/components/element-cache/element-cache.component';

import { LogsService } from './analytics/logs/services/logs.service';
import { SelectVnaServiceComponent } from './config/vna_services/components/select-vna-service/select-vna-service.component';
import {VnaServiceService} from './config/vna_services/services/vna-service.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {OwlMomentDateTimeModule} from 'ng-pick-datetime-moment';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { OutlayReportingComponent } from './analytics/outlay/components/outlay-reporting/outlay-reporting.component';
import {OutlayService} from './analytics/outlay/services/outlay.service';
import { OutlayEvolutionComponent } from './analytics/outlay/components/outlay-evolution/outlay-evolution.component';
import { StatsComponent } from './analytics/stats/components/stats/stats.component';
import { SelectConfigStatsComponent } from './analytics/stats/components/select-config-stats/select-config-stats.component';
import {StatsService} from './analytics/stats/services/stats.service';
import { SelectVnaCampaignComponent } from './config/vna-campaign/components/select-vna-campaign/select-vna-campaign.component';
import {VnaCampaignService} from './config/vna-campaign/services/vna-campaign.service';
import { SelectVnaCampaignActionComponent } from './config/vna-campaign/components/select-vna-campaign-action/select-vna-campaign-action.component';
import { EditCampaignComponent} from './config/vna-campaign/components/edit-campaign/edit-campaign.component';
import { PortalServiceFactoryService} from './config/services/portal-service-factory.service';
import { OrderModule} from 'ngx-order-pipe';
// Components
import { ListProvidersComponent } from './config/providers/components/list-providers/list-providers.component';
import { UpdateModalComponent} from './config/providers/modals/update-modal/update-modal.component';
import { ElementLogViewModalComponent} from './tools/elements/modals/element-log--view-modal/element-log-view-modal.component';
// Services
import { ProvidersService} from './config/providers/services/providers.service';
import { ElementLogsService} from './tools/elements/services/element-logs.service';
import { ElementCacheService} from './tools/elements/services/element-cache.service';
import { AttemptProviderChangeService} from './config/vna_portal/services/attempt-provider-change.service';
import { PricingService} from './config/pricing/services/pricing.service';
import { ElementCacheViewModalComponent } from './tools/elements/modals/element-cache-view-modal/element-cache-view-modal.component';
import { CacheDeleteFromFileModalComponent } from './tools/elements/modals/cache-delete-from-file-modal/cache-delete-from-file-modal.component';

import { Ng2FileInputModule} from 'ng2-file-input';
import {FileUploadService} from './tools/elements/services/file-upload.service';
import { FileUploadModule } from 'ng2-file-upload';

import { StatsChartModalComponent } from './analytics/stats/components/modal/stats-chart-modal/stats-chart-modal.component';
import { PortalServicesComponent } from './config/vna_portal/components/portal-services/portal-services.component';
import {VnaPortalService} from './config/vna_portal/services/vna-portal.service';
import { EditPortalServiceComponent } from './config/vna_portal/components/edit-portal-service/edit-portal-service.component';
import { CallRangeAllowedComponent } from './config/form/components/call-range-allowed/call-range-allowed.component';
import { StatsConfigComponent } from './analytics/stats/components/stats-config/stats-config.component';
import { TagInputModule } from 'ngx-chips';

import { ListPricingComponent } from './config/pricing/components/list-pricing/list-pricing.component';
import { EditPricingModalComponent } from './config/pricing/modals/edit-pricing-modal/edit-pricing-modal.component';

import {StatsConfigService} from './analytics/stats/services/stats-config.service';
import { BeeztelCodesListComponent } from './tools/beeztel-codes/components/beeztel-codes-list/beeztel-codes-list.component';
import {BeeztelCodesService} from './tools/beeztel-codes/services/beeztel-codes.service';
import { BeeztelCodesEditComponent } from './tools/beeztel-codes/modals/beeztel-codes-edit/beeztel-codes-edit.component';
import { MappingChangeListComponent } from './tools/beeztel-codes/components/mapping-change-list/mapping-change-list.component';
import { MappingCodeStrPipe } from './tools/beeztel-codes/pipes/mapping-code-str.pipe';
import { CodeMappingChangeEditComponent } from './tools/beeztel-codes/modals/code-mapping-change-edit/code-mapping-change-edit.component';
import { ListVnaCampaignsComponent } from './config/vna-campaign/components/list-vna-campaigns/list-vna-campaigns.component';
import { VnaCampaignActionsComponent } from './config/vna-campaign/components/vna-campaign-actions/vna-campaign-actions.component';
import { VnaCampaignActionEditComponent } from './config/vna-campaign/modals/vna-campaign-action-edit/vna-campaign-action-edit.component';
import { VnaCampaignActionFilePreviewComponent } from './config/vna-campaign/modals/vna-campaign-action-file-preview/vna-campaign-action-file-preview.component';
import { TestPortalServiceComponent } from './config/vna_portal/components/test-portal-service/test-portal-service.component';

import { BasicParametersComponent } from './config/form/components/basic-parameters/basic-parameters.component';
import {VnaPortalConfigDataParserService} from './config/vna_portal/services/vna-portal-config-data-parser.service';
import { ExternalCallbackComponent } from './config/form/components/external-callback/external-callback.component';

import { AttemptsProviderChangeComponent } from './config/vna_portal/components/attempts-provider-change/attempts-provider-change.component';
import { AttemptProviderChangeModalComponent } from './config/vna_portal/modals/attempt-provider-change-modal/attempt-provider-change-modal.component';
import { ServiceAccessComponent } from './config/form/components/service-access/service-access.component';
import { ExternalCallbackListComponent } from './config/vna_portal/components/external-callback-list/external-callback-list.component';
import { ExtCallbackLeadsViewModalComponent } from './config/vna_portal/modals/ext-callback-leads-view-modal/ext-callback-leads-view-modal.component';
import { ResponseConfigDelayComponent } from './config/vna_portal/components/response-config-delay/response-config-delay.component';
import { ResponseConfigDelayModalComponent } from './config/vna_portal/modals/response-config-delay-modal/response-config-delay-modal.component';
import { ResponseConfigDelayService} from './config/vna_portal/services/response-config-delay.service';
import { ServiceProviderPriceComponent } from './config/vna_portal/components/service-provider-price/service-provider-price.component';
import {ServiceProviderPriceService} from './config/vna_portal/services/service-provider-price.service';
import { ServiceProviderPriceModalComponent } from './config/vna_portal/modals/service-provider-price-modal/service-provider-price-modal.component';
import { UpdateServiceProviderPricingModalComponent } from './config/vna_portal/modals/update-service-provider-pricing-modal/update-service-provider-pricing-modal.component';
import { HlrContextComponent } from './config/hlr/components/hlr-context/hlr-context.component';
import {HlrContextService} from './config/hlr/services/hlr-context.service';
import { EditHlrContextComponent } from './config/hlr/modals/edit-hlr-context/edit-hlr-context.component';
import { SelectHlrContextComponent } from './config/hlr/components/select-hlr-context/select-hlr-context.component';
import { OrderStatsByPipe } from './analytics/stats/pipe/order-stats-by.pipe';
import { AvgHidePipe } from './analytics/stats/pipe/avg-hide.pipe';
import { VnaCampaignCreateComponent } from './config/vna-campaign/modals/vna-campaign-create/vna-campaign-create.component';
import { LastPortalStatsComponent } from './analytics/stats/components/modal/last-portal-stats/last-portal-stats.component';
import { StatsValueCompareComponent } from './analytics/stats/components/stats-value-compare/stats-value-compare.component';
import { SelectTimezoneComponent } from './config/vna_portal/components/select-timezone/select-timezone.component';
import {PortalTimezoneService} from './config/vna_portal/services/portal-timezone.service';
import { CallTraceComponent } from './tools/trace/components/call-trace/call-trace.component';
import {CallTraceService} from './tools/trace/services/call-trace.service';
import {OutlayColumnsConfigService} from './analytics/outlay/services/outlay-columns-config.service';
import { BeeztelBasicParametersComponent } from './config/form/components/beeztel/beeztel-basic-parameters/beeztel-basic-parameters.component';
import { ChaconSmsBasicParametersComponent } from './config/form/components/chacon-sms/chacon-sms-basic-parameters/chacon-sms-basic-parameters.component';
import { BeeztelCallRangeAllowedComponent } from './config/form/components/beeztel/beeztel-call-range-allowed/beeztel-call-range-allowed.component';
import { ChaconSmscallRangeAllowedComponent } from './config/form/components/chacon-sms/chacon-smscall-range-allowed/chacon-smscall-range-allowed.component';
import { BeeztelServiceAccessComponent } from './config/form/components/beeztel/beeztel-service-access/beeztel-service-access.component';
import { ChaconSmsserviceAccessComponent } from './config/form/components/chacon-sms/chacon-smsservice-access/chacon-smsservice-access.component';
import { ChaconSmssendParametersComponent } from './config/form/components/chacon-sms/chacon-smssend-parameters/chacon-smssend-parameters.component';
import { VerticalParametersComponent } from './config/form/components/vertical-parameters/vertical-parameters.component';
import { EditCampaignActionComponent } from './config/vna-campaign/components/edit-campaign-action/edit-campaign-action.component';
import {VnaCampaignActionService} from './config/vna-campaign/services/vna-campaign-action.service';
import { CacheConfigComponent } from './config/form/components/cache-config/cache-config.component';
import { CallCenterParametersComponent } from './config/form/components/call-center-parameters/call-center-parameters.component';
import { ListCampaignPbxConfigComponent } from './config/vna-campaign/components/list-campaign-pbx-config/list-campaign-pbx-config.component';
import {VnaCampaignPbxConfigService} from './config/vna-campaign/services/vna-campaign-pbx-config.service';
import { VnaCampaignPbxConfigEditComponent } from './config/vna-campaign/modals/vna-campaign-pbx-config-edit/vna-campaign-pbx-config-edit.component';
import { ResendLeadsExternalCallbackComponent } from './config/vna-campaign/modals/resend-leads-external-callback/resend-leads-external-callback.component';
import {ExternalCallbackService} from './config/vna-campaign/services/external-callback.service';
import { ExportExternalCallbackComponent } from './config/form/components/export-external-callback/export-external-callback.component';
import { StatusFromUrlSentPipe } from './config/vna_portal/pipes/status-from-url-sent.pipe';
import { BeeztelServiceAccessUrlVarsComponent } from './config/form/components/beeztel/beeztel-service-access-url-vars/beeztel-service-access-url-vars.component';
import { VnaCallerIdComponent } from './config/caller-id/components/vna-caller-id/vna-caller-id.component';
import { VnaCallerIdEditComponent } from './config/caller-id/modals/vna-caller-id-edit/vna-caller-id-edit.component';
import {VnaCallerIdService} from './config/caller-id/services/vna-caller-id.service';
import { SelectCallerIdsComponent } from './config/caller-id/components/select-caller-ids/select-caller-ids.component';
import { CallerIdAssignComponent } from './config/caller-id/modals/caller-id-assign/caller-id-assign.component';
import { RedirectLogComponent } from './config/vna-campaign/modals/redirect-log/redirect-log.component';
import {RedirectLogService} from './config/vna-campaign/services/redirect-log.service';
import { NrsBasicParametersComponent } from './config/form/components/nrs/nrs-basic-parameters/nrs-basic-parameters.component';
import { NrsServiceAccessComponent } from './config/form/components/nrs/nrs-service-access/nrs-service-access.component';
import { SelectSmsLineAccountComponent } from './config/sms/components/select-sms-line-account/select-sms-line-account.component';
import {SmsLineAccountService} from './config/sms/services/sms-line-account.service';
import { ServiceToPortalComponent } from './config/vna_portal/modals/service-to-portal/service-to-portal.component';
import { LineTypeMappingChangePipe } from './tools/beeztel-codes/pipes/line-type-mapping-change.pipe';
import { AgileSmsBasicParametersComponent } from './config/form/components/agile_sms/agile-sms-basic-parameters/agile-sms-basic-parameters.component';
import { ProviderCallerIdComponent } from './config/providers/components/provider-caller-id/provider-caller-id.component';
import { ProviderCallerIdUpdateComponent } from './config/providers/modals/provider-caller-id-update/provider-caller-id-update.component';
import { CampOverridedConfigComponent } from './config/vna-campaign/modals/camp-overrided-config/camp-overrided-config.component';
import { IconServicePipe } from './config/vna_services/pipe/icon-service.pipe';
import { SelectVnaCampaignMultipleComponent } from './config/vna-campaign/components/select-vna-campaign-multiple/select-vna-campaign-multiple.component';
import { SelectVnaCampaignActionMultipleComponent } from './config/vna-campaign/components/select-vna-campaign-action-multiple/select-vna-campaign-action-multiple.component';
import { LogsTableComponent } from './tools/elements/components/logs-table/logs-table.component';
import { CampaignDataComponent } from './tools/elements/components/campaign-data/campaign-data.component';
import { ExternalCallbackFiltersComponent } from './config/vna-campaign/modals/external-callback-filters/external-callback-filters.component';
import { PriorityListComponent } from './config/priorities/components/priority-list/priority-list.component';
import {PriorityService} from './config/priorities/services/priority.service';
import { EditPriorityComponent } from './config/priorities/modals/edit-priority/edit-priority.component';
import { ExternalCallbackNavComponent } from './config/form/components/external-callback-nav/external-callback-nav.component';
import { ExternalCallbackMappingComponent } from './config/form/components/external-callback-mapping/external-callback-mapping.component';
import { ActionReportingComponent } from './config/vna-campaign/components/action-reporting/action-reporting.component';
import { ListCampaignPrefixConfigComponent } from './config/vna-campaign/components/list-campaign-prefix-config/list-campaign-prefix-config.component';
import {CampaignPrefixConfigService} from './config/vna-campaign/services/campaign-prefix-config.service';
import { CampaignPrefixConfigEditComponent } from './config/vna-campaign/modals/campaign-prefix-config-edit/campaign-prefix-config-edit.component';
import { VerificationCallerIdsComponent } from './config/caller-id/components/verification-caller-ids/verification-caller-ids.component';
import { CallerIdCampaignsComponent } from './config/caller-id/modals/caller-id-campaigns/caller-id-campaigns.component';
import { SelectVnaCallerIdCampaignComponent } from './config/vna-campaign/components/select-vna-caller-id-campaign/select-vna-caller-id-campaign.component';
import { CallerIdsFileUploadComponent } from './config/caller-id/modals/caller-ids-file-upload/caller-ids-file-upload.component';


export const MY_MOMENT_FORMATS = {
    parseInput: 'l LT',
    fullPickerInput: 'YYYY-MM-DD HH:mm:ss',
    datePickerInput: 'l',
    timePickerInput: 'LT',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        TabsModule.forRoot(),
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        BrowserModule,
        BrowserAnimationsModule,
        Ng2SmartTableModule,
        Ng2FileInputModule.forRoot(),
        FileUploadModule,
        ChartsModule,
        NgxSelectModule,
        TagInputModule,
        DpDatePickerModule,
        TooltipModule.forRoot(),
        OrderModule,
        DndModule.forRoot(),
        NgxJsonViewerModule,
        NgCircleProgressModule.forRoot({
            // set defaults here
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: "#78C000",
            innerStrokeColor: "#C7E596",
            animationDuration: 300
        })
    ],
    entryComponents: [
        UpdateModalComponent,
        ElementLogViewModalComponent,
        ElementCacheViewModalComponent,
        CacheDeleteFromFileModalComponent,
        StatsChartModalComponent,
        EditPricingModalComponent,
        BeeztelCodesEditComponent,
        CodeMappingChangeEditComponent,
        VnaCampaignActionEditComponent,
        VnaCampaignActionFilePreviewComponent,
        TestPortalServiceComponent,
        AttemptProviderChangeModalComponent,
        ExternalCallbackComponent,
        ExtCallbackLeadsViewModalComponent,
        ResponseConfigDelayModalComponent,
        ServiceProviderPriceModalComponent,
        UpdateServiceProviderPricingModalComponent,
        EditHlrContextComponent,
        VnaCampaignCreateComponent,
        LastPortalStatsComponent,
        VnaCampaignPbxConfigEditComponent,
        ResendLeadsExternalCallbackComponent,
        ExportExternalCallbackComponent,
        BeeztelServiceAccessUrlVarsComponent,
        VnaCallerIdEditComponent,
        CallerIdAssignComponent,
        RedirectLogComponent,
        ServiceToPortalComponent,
        ProviderCallerIdUpdateComponent,
        CampOverridedConfigComponent,
        ExternalCallbackFiltersComponent,
        ExternalCallbackListComponent,
        ExternalCallbackMappingComponent,
        EditPriorityComponent,
        CampaignPrefixConfigEditComponent,
        CallerIdCampaignsComponent,
        CallerIdsFileUploadComponent
    ],
    declarations: [
        ListVnaServicesComponent,
        ListLogsComponent,
        //SelectVnaServiceComponent,
        OutlayReportingComponent,
        OutlayEvolutionComponent,
        ListProvidersComponent,
        UpdateModalComponent,
        ElementLogsComponent,
        ElementLogViewModalComponent,
        ElementCacheComponent,
        ElementCacheViewModalComponent,
        CacheDeleteFromFileModalComponent,
        StatsComponent,
        SelectConfigStatsComponent,
        SelectVnaCampaignComponent,
        SelectVnaCampaignActionComponent,
        StatsChartModalComponent,
        PortalServicesComponent,
        EditPortalServiceComponent,
        //CallRangeAllowedComponent,
        StatsConfigComponent,
        ListPricingComponent,
        EditPricingModalComponent,
        BeeztelCodesListComponent,
        BeeztelCodesEditComponent,
        MappingChangeListComponent,
        MappingCodeStrPipe,
        CodeMappingChangeEditComponent,
        ListVnaCampaignsComponent,
        VnaCampaignActionsComponent,
        VnaCampaignActionEditComponent,
        VnaCampaignActionFilePreviewComponent,
        TestPortalServiceComponent,
        //BasicParametersComponent,
        ExternalCallbackComponent,
        AttemptsProviderChangeComponent,
        AttemptProviderChangeModalComponent,
        //ServiceAccessComponent,
        ExternalCallbackListComponent,
        ExtCallbackLeadsViewModalComponent,
        ResponseConfigDelayComponent,
        ResponseConfigDelayModalComponent,
        EditCampaignComponent,
        ServiceProviderPriceComponent,
        ServiceProviderPriceModalComponent,
        UpdateServiceProviderPricingModalComponent,
        HlrContextComponent,
        EditHlrContextComponent,
        SelectHlrContextComponent,
        OrderStatsByPipe,
        AvgHidePipe,
        VnaCampaignCreateComponent,
        LastPortalStatsComponent,
        StatsValueCompareComponent,
        SelectTimezoneComponent,
        CallTraceComponent,
        BeeztelBasicParametersComponent,
        ChaconSmsBasicParametersComponent,
        BeeztelCallRangeAllowedComponent,
        ChaconSmscallRangeAllowedComponent,
        BeeztelServiceAccessComponent,
        ChaconSmsserviceAccessComponent,
        ChaconSmssendParametersComponent,
        VerticalParametersComponent,
        EditCampaignActionComponent,
        CacheConfigComponent,
        CallCenterParametersComponent,
        ListCampaignPbxConfigComponent,
        VnaCampaignPbxConfigEditComponent,
        ResendLeadsExternalCallbackComponent,
        ExportExternalCallbackComponent,
        StatusFromUrlSentPipe,
        BeeztelServiceAccessUrlVarsComponent,
        VnaCallerIdComponent,
        VnaCallerIdEditComponent,
        SelectCallerIdsComponent,
        CallerIdAssignComponent,
        RedirectLogComponent,
        NrsBasicParametersComponent,
        NrsServiceAccessComponent,
        SelectSmsLineAccountComponent,
        ServiceToPortalComponent,
        LineTypeMappingChangePipe,
        AgileSmsBasicParametersComponent,
        ProviderCallerIdComponent,
        ProviderCallerIdUpdateComponent,
        CampOverridedConfigComponent,
        IconServicePipe,
        SelectVnaCampaignMultipleComponent,
        SelectVnaCampaignActionMultipleComponent,
        LogsTableComponent,
        CampaignDataComponent,
        ExternalCallbackFiltersComponent,
        PriorityListComponent,
        EditPriorityComponent,
        ExternalCallbackNavComponent,
        ExternalCallbackMappingComponent,
        ActionReportingComponent,
        ListCampaignPrefixConfigComponent,
        CampaignPrefixConfigEditComponent,
        VerificationCallerIdsComponent,
        CallerIdCampaignsComponent,
        SelectVnaCallerIdCampaignComponent,
        CallerIdsFileUploadComponent,
    ],

    providers: [
        LogsService,
        OutlayService,
        VnaServiceService,
        StatsService,
        StatsConfigService,
        BeeztelCodesService,
        VnaCampaignService,
        VnaCampaignActionService,
        ProvidersService,
        ElementLogsService,
        ElementCacheService,
        FileUploadService,
        VnaPortalService,
        PricingService,
        VnaPortalConfigDataParserService,
        AttemptProviderChangeService,
        ResponseConfigDelayService,
        PortalServiceFactoryService,
        ServiceProviderPriceService,
        HlrContextService,
        PortalTimezoneService,
        CallTraceService,
        OutlayColumnsConfigService,
        VnaCampaignPbxConfigService,
        CampaignPrefixConfigService,
        ExternalCallbackService,
        VnaCallerIdService,
        RedirectLogService,
        SmsLineAccountService,
        PriorityService,
        {provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS}
    ]
})
export class PhoneModule { }



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/phone.module.ts